module.exports = __webpack_public_path__ + "img/c00_buildingpriceadjusting_Normal_ua.0523bfb1.webp";